import { formatClock } from '../MentorAvailabilityPanel';
import type { MenteeBookingRow } from './MenteePortalService';
import { formatModeLabel } from './menteeSessionsFormat';

type Props = {
    bookings: MenteeBookingRow[];
    menteeName: string | null;
    isLoading: boolean;
    loadError: string | null;
    onEditAgenda: (booking: MenteeBookingRow) => void;
};

const renderJoin = (link: string | null | undefined) => {
    const trimmed = (link || '').trim();
    if (!trimmed) {
        return <span className="msess-muted">No link provided</span>;
    }
    return (
        <a href={trimmed} target="_blank" rel="noopener noreferrer" className="btn-green btn-sm rounded-pill px-4 py-2 h-auto">
            <span>Join</span>
        </a>
    );
};

const MenteeSessionsUpcoming = ({
    bookings,
    menteeName,
    isLoading,
    loadError,
    onEditAgenda,
}: Props) => {
    if (loadError) {
        return <p className="mreg-banner is-danger">{loadError}</p>;
    }
    if (isLoading) {
        return <p className="msess-empty">Loading upcoming sessions…</p>;
    }
    if (bookings.length === 0) {
        return (
            <p className="msess-empty">
                No upcoming sessions. Book a 1:1 from the Book a Session tab when your mentor has
                availability.
            </p>
        );
    }

    return (
        <div className="msess-list-card">
            <p className="msess-tz">Times are shown as Asia/Kolkata (IST).</p>
            <div className="row g-3">
                {bookings.map((row) => (
                    <div key={row.id} className="col-md-4 col-sm-6">
                        <div className="bg-success bg-opacity-10 border border-success border-opacity-25 rounded-3 p-3 font-13 text-black lh-base">
                            <p className="msess-upcoming-when">
                                {row.bookedDate || '—'} ·{' '}
                                {formatClock(Number(row.startMinute || 0))}
                                {row.durationMinutes != null ? ` · ${row.durationMinutes} min` : ''}
                            </p>
                            <div className="font-16 font-600 text-black d-flex align-items-center gap-1">
                                                            <span className="font-16 font-600 text-black">1:1</span> 
                                                            <span className="badge bg-white text-dark rounded-pill mx-2 font-12 font-500 py-2 px-3 shadow-sm" >
                                                                {formatModeLabel(row.mode)}
                                                            </span>
                                                        </div>
                           
                            <p className="font-14 font-weight-500 text-dark mb-0">{row.topic || '—'}</p>
                            {row.agenda ? (
                                <p className="font-14  text-dark mb-0">
                                    <strong className='font-weight-500'>Agenda:</strong> {row.agenda}
                                </p>
                            ) : null}
                            <p className="font-14  text-dark mb-0">
                                Booked by: {menteeName || 'You'}
                            </p>

                            <div className="d-flex gap-2 mt-3">
                            {renderJoin(row.sessionLink)}
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary rounded-pill px-3 py-2"
                                onClick={() => onEditAgenda(row)}
                            >
                                {row.agenda ? 'Edit agenda' : 'Add agenda'}
                            </button>
                        </div>
                        </div>
                        
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MenteeSessionsUpcoming;
